import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";

const ViewPostSite = (props) => {
    document.title = "DirtMap - Listing Details";

    const history = useHistory();
    // const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [postSite, setPostSite] = useState([]);
    const userId = localStorage.getItem('user_id');

    useEffect(() => {
        let isMounted = true;
        axios.get(`api/detail/post/site/${props.match.params.id}/${userId}`).then(res => {
            if (isMounted) {
                if (res.data.result) {
                    setPostSite(res.data.result);
                    setLoading(false);
                } else if (res.data.status === 'false') {
                    history.push('/');
                    swal("warning", res.data.message, "error");
                }
            }
        });
        return () => {
            isMounted = false;
        };
    }, [props.match.params.id, history]);
    var detailpostsite_HTMLTABLE = "";
    if (loading) {
        return <div className="fp-container"><img src={"/images/spinner.gif"} className="fp-loader" alt="loading" /></div>;
    } else {
        detailpostsite_HTMLTABLE =
            postSite.images.map((image, index) => {
                // let imgStr = image.substring(image.lastIndexOf("/") + 1);
                return (<div>
                    <div className="col-sm-3">
                        <img height="300" width="400" src={image} className="img-responsive" alt="itemImage" />
                    </div>
                </div>)
            });
    }
    return (
        <main className="main">
            <div className="container-fluid">
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                        <div className="row align-items-center">
                            <div className="col-sm-12">
                                <h4 className="card-title mb-0">Listings Details</h4>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-bordered" width="100%">
                                <tbody>
                                    <tr>
                                        <th >Item Type:</th>
                                        <td>{postSite.item_type}</td>
                                    </tr>
                                    <tr>
                                        <th >Project Name:</th>
                                        <td>{postSite.project_name}</td>
                                    </tr>
                                    <tr>
                                        <th >Cuyds Of Dirt:</th>
                                        <td>{postSite.cuyds_of_dirt_min}</td>
                                    </tr>
                                    {/* <tr>
                                        <th >Cuyds Of Dirt Max:</th>
                                        <td>{postSite.cuyds_of_dirt_max}</td>
                                    </tr> */}
                                    <tr>
                                        <th >Address:</th>
                                        <td>{postSite.address}</td>
                                    </tr>
                                    <tr>
                                        <th >Latitude:</th>
                                        <td>{postSite.latitude}</td>
                                    </tr>
                                    <tr>
                                        <th >Longitude:</th>
                                        <td>{postSite.longitude}</td>
                                    </tr>
                                    <tr>
                                        <th >Mobile Number:</th>
                                        <td>{postSite.phone}</td>
                                    </tr>
                                    <tr>
                                        <th >Description:</th>
                                        <td>{postSite.description}</td>
                                    </tr>
                                    <tr>
                                        <th >Special Instruction:</th>
                                        <td>{postSite.special_instruction}</td>
                                    </tr>
                                    <tr>
                                        <th >Name:</th>
                                        <td>{postSite.name}</td>
                                    </tr>
                                    <tr>
                                        <th >Email:</th>
                                        <td>{postSite.email}</td>
                                    </tr>
                                    <tr>
                                        <th >Phone:</th>
                                        <td>{postSite.phone}</td>
                                    </tr>
                                    <tr>
                                        <th>Status:</th>
                                        <td className="center">
                                            {postSite.status === '1' ? 'Active' : 'Inactive'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Document:</th>
                                        <td className="center">
                                            <a target="_blank" href={postSite.document} download="document">
                                                <i className="fas fa-file-image fa-3x"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-header">
                        <div className="row align-items-center">
                            <div className="col-sm-12">
                                <h4 className="card-title mb-0">Video</h4>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row align-items-center">
                            <video width="320" height="240" controls>
                                <source src={postSite.video} type="video/mp4" />
                                <source src={postSite.video} type="video/ogg" />
                            </video>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-header">
                        <div className="row align-items-center">
                            <div className="col-sm-12">
                                <h4 className="card-title mb-0">Images</h4>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row align-items-center">
                            {detailpostsite_HTMLTABLE}
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default ViewPostSite;